module.exports = __webpack_public_path__ + "img/wifi-off.638bc95c.svg";